import {
  AfterViewInit,
  ChangeDetectorRef,
  Component, ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Output, Renderer2,
  Self,
  ViewChild
} from '@angular/core';
import {hasGruppeTechnischeSteuerung, Wertemenge} from '../../../models/uiArtefakt';
import {ControlContainer, ControlValueAccessor, NgControl, NgForm, NgModel} from '@angular/forms';
import {MatFormFieldControl} from '@angular/material/form-field';
import {BehaviorSubject, combineLatest, Subject, Subscription} from 'rxjs';
import {MatSelectChange} from '@angular/material/select';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';
import {WertemengenService} from '../../../services/wertemengen.service';
import {tap} from 'rxjs/operators';
import {EventService} from '../../../services/event.service';
import {EnumGruppeTechnischeSteuerung, hasAvvEinwilligung} from '../../../models/enumGruppeTechnischeSteuerung';
import {StageConfigService} from '../../../services/stage-config.service';

export class TelefonWertEingabe {
  laendervorwahl: string;
  nummer: string;
}

@Component({
    selector: 'lv-telefonnummer-inputs',
    templateUrl: './telefonnummer-inputs.component.html',
    styleUrls: ['./telefonnummer-inputs.component.scss'],
    providers: [{ provide: MatFormFieldControl, useExisting: TelefonnummerInputsComponent }],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false
})
export class TelefonnummerInputsComponent implements OnInit, OnDestroy, ControlValueAccessor, MatFormFieldControl<string>, AfterViewInit {
  @Input()
  errorState: boolean;

  @Output()
  public focusEvent: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild('phonenumberInput', {static: true})
  private _phonenumberInput: NgModel;

  public telefonWertEingabe: TelefonWertEingabe = {
    laendervorwahl: '+49',
    nummer: ''
  };

  public isDisabled: boolean = false;
  public value: string | null;
  public loadedOptions$;
  public autocomplete: string;
  readonly autofilled: boolean;
  readonly controlType: string;
  readonly disabled: boolean;
  readonly empty: boolean;
  readonly focused: boolean;
  readonly id: string;
  readonly placeholder: string;
  readonly required: boolean;
  readonly shouldLabelFloat: boolean;
  readonly stateChanges = new Subject<void>();
  readonly userAriaDescribedBy: string;

  private _subscription = Subscription.EMPTY;
  private _uiArtefakt: Wertemenge;

  constructor(@Optional() @Self() public ngControl: NgControl, private _eventService: EventService,
              private cd: ChangeDetectorRef, private _wertemengenService: WertemengenService,
              private _stageConfigService: StageConfigService,
              private _renderer: Renderer2, private _element: ElementRef) {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  get uiArtefakt() {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: Wertemenge) {
    this._uiArtefakt = uiArtefakt;
    if (!!this._uiArtefakt.WertEingabe) {
      this.telefonWertEingabe.nummer = this._uiArtefakt.WertEingabe.nummer;
      this.telefonWertEingabe.laendervorwahl = this._uiArtefakt.WertEingabe.laendervorwahl;
    }
    this.isDisabled = this._uiArtefakt?.Darstellungsart === UIDarstellungsart.DISABLED ||
        !hasAvvEinwilligung(hasGruppeTechnischeSteuerung(
                this.uiArtefakt, EnumGruppeTechnischeSteuerung.AVVEINWILLIGUNG),
            this._eventService.avvEinwilligungImAntrag$.getValue(),
            this._eventService.vermittlerdatenFuerAvvGesetzt$.getValue());
  }

  ngOnInit(): void {
    this.loadedOptions$ = this._wertemengenService.filteredOptions$.pipe(tap(_ => this.cd.detectChanges()));
    this._subscription = combineLatest([this.ngControl.statusChanges, this._phonenumberInput.statusChanges]).subscribe(() => {
      if (!this.ngControl.control.errors && this._phonenumberInput.errors) {
        this.ngControl.control.setErrors(this._phonenumberInput.errors);
      }
      if (!this.ngControl.control.dirty && this._phonenumberInput.dirty) {
        this.ngControl.control.markAsDirty();
      }
    });
    this._wertemengenService.filterWertemenge(this.uiArtefakt, '', [], 1000);
    this.autocomplete = this._stageConfigService.getInputAutocomplete();
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnDestroy(): void {
    if (this._subscription) {
      this._subscription.unsubscribe();
    }
  }

  public setNummer(value: any) {
    if (value + '' === this.telefonWertEingabe.nummer + '') {
      return;
    }
    this.telefonWertEingabe.nummer = value;
    this._onChange(this.telefonWertEingabe);
  }

  setVorwahl(change: MatSelectChange) {
    this.telefonWertEingabe.laendervorwahl = change.value;
    this._onChange(this.telefonWertEingabe);
  }

  public writeValue(value: string): void {
    this.value = value;
  }

  public registerOnChange(fn: (_: any) => void): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  onContainerClick(event: MouseEvent): void {
  }

  setDescribedByIds(ids: string[]): void {
  }

  private _onChange = (_: any) => void 0;
  private _onTouched = () => void 0;

}
